// globals: $j, I4Go, IDTech

import CardConnectEMVTerminal from './CardConnect/cardConnectEMVTerminal';
import I4goEMVTerminal from './i4go-frame/I4goEMVTerminal';
import CashFlowEMVTerminal from './CashFlow/cashFlowEMVTerminal';

/**
 * Take payment controller
 */
var TakePayment = {

    /**
     * Params
     */
    params: {},

    /**
     * Enter Manually
     */
    enterManually: function(element) {
        var self = this;
        if (this.params.useKeySecureDevice) {
            var $form = $j(element).closest('form');
            self.idTechManuallyStart($form, function() {
                $j(element).hide();
                var $payButton = $j('#ccpayButton');
                $payButton.show();
                $j('#ccInfo-user_name').focus();
                self.pay($payButton.get(0));
            });
        } else {
            $j('#manualCCFields').slideDown(100);
            $j(element).hide();
            if (!this.params.isIframeGateway) {
                $j('#ccpayButton').show();
            }
            $j('#ccInfo-user_name').focus();
        }
    },

    /**
     * IdTech SWIPE Start
     */
    idTechSwipeStart: function($form, onComplete) {
        this.idTechStart('Retail', $form, onComplete);
    },

    /**
     * IdTech Manually Start
     */
    idTechManuallyStart: function($form, onComplete) {
        this.idTechStart('Global', $form, onComplete);
    },

    /**
     * IdTech Start
     */
    idTechStart: function(type, $form, onComplete) {
        var idTech = new IDTech();

        var text = '';
        if (type == 'Global') {
            text = 'Please enter the card number to proceed...';
        } else {
            text = 'Waiting for swipe action...';
        }

        var accountType = 'Global';

        idTech.start(
            text,
            {
                onComplete: function(block) {

                    //var block = '02B100C037001C0B1692;432100******1119=1709:***?*165=065000=808692B85DAF4F383BC729734C501EB00F3BCB2422A30D0ACA257AFA5305E68893A5F43E56BD76465F78F94CFE2064E4D23C312862994950010A0D600014401203';

                    var $i4goP2peBlock = $form.find('[name=i4go_p2peblock]');
                    if ($i4goP2peBlock.length) {
                        $i4goP2peBlock.val(block);
                    } else {
                        $form.append(
                            '<input type="hidden" name="i4go_p2peblock" value="' + block + '">'
                        );
                    }

                    var $i4goAccountType = $form.find('[name=i4go_account_type]');
                    if ($i4goAccountType.length) {
                        $i4goAccountType.val(accountType);
                    } else {
                        $form.append(
                            '<input type="hidden" name="i4go_account_type" value="' + accountType + '">'
                        );
                    }

                    onComplete();
                },
            }
        );
    },

    /**
     * On click pay button
     */
    pay: function(element) {
        element.disabled='disabled';
        element.form.cc_type.value = 'info';
        var i4go = new I4go();
        i4go.getCardData = function(formParamsArray) {
            var cardData = {};
            var associationKeys = {
                'ccInfo[ccNumber]' : 'i4go_cardnumber',
                'ccInfo[user_name]' : 'i4go_cardholdername',
                'bill_cvv' : 'i4go_cvv2Code',
                'ccInfo[zip]' : 'i4go_postalcode',
                i4go_p2peblock: 'i4go_p2peblock',
                i4go_account_type: 'i4go_account_type'
            };
            for (var i in formParamsArray) {
                var item = formParamsArray[i];
                if (associationKeys[item.name]) {
                    cardData[associationKeys[item.name]] = item.value;
                }
                if (item.name == 'ccInfo[expDate]') {
                    var expDate = item.value;
                    cardData.i4go_expirationmonth = expDate.slice(0, 2);
                    cardData.i4go_expirationyear = expDate.slice(2, 4);
                }
            }
            if (!cardData.i4go_cardholdername) {
                for (var i in formParamsArray) {
                    var item = formParamsArray[i];
                    if (item.name == 'user_name_default') {
                        cardData.i4go_cardholdername = item.value;
                    }
                }
            }
            return cardData;
        };
        i4go.formChange(element.form, function(result) {
            if (!result) {
                jQuery(element).removeAttr('disabled');
                return false;
            }
            element.form.onsubmit();
        });
    },

    /**
     * Call EMV Terminal
     *
     * @param params
     * @param callback
     */
    callTerminal: function(params, callback) {
        var shift4Active = jQuery('#shift4_active').val();
        var cardConnectActive = jQuery('#cardconnect_active').val();
        var cashFlowActive = jQuery('#cashflow_active').val();
        var gatewayTerminal;

        if(shift4Active) {
            gatewayTerminal = new I4goEMVTerminal();
        } else if(cardConnectActive) {
            gatewayTerminal = new CardConnectEMVTerminal();
        } else if(cashFlowActive) {
            gatewayTerminal = new CashFlowEMVTerminal();
        }

        gatewayTerminal.callTerminal(params, callback);
    },

    /** Call EMV Terminal
     *
     * @param params
     * @param callback
     */
    callTokenizationTerminal: function(params, callback) {
        const cashFlowActive = jQuery('#cashflow_active').val();
        let gatewayTerminal;

        if (cashFlowActive) {
            gatewayTerminal = new CashFlowEMVTerminal();
            gatewayTerminal.callTokenizationTerminal(params, callback);
        }

        return;
    },
    
    /**
     * Pay with POS terminal
     */
    payWithTerminal: function(element) {
        this.callTerminal(this.params, function(data) {
            try {
                element.disabled = 'disabled';
                var cashFlowActive = jQuery('#cashflow_active').val();

                if (cashFlowActive) {
                    let expirationDate = data.cardData.expirationDate;
                    if (expirationDate.indexOf('/') > -1) {
                        const expirationDateArray = expirationDate.split('/');
                        const expirationMonth = expirationDateArray[0];
                        const expirationYear = expirationDateArray[1];
                        expirationDate = expirationMonth + expirationYear;
                    }

                    let emvResponse = {
                        'token': data.token,
                        'amount': data.amount,
                        'transactionId': data.transactionId,
                        'expirationDate': expirationDate,
                        'lastFour': data.cardData.lastFour,
                        'cardHolderName': data.cardData.cardHolderName,
                        'ccType': data.brand,
                        'emvSessionKey': true,
                        'responseMessage': data.responseMessage,
                        'platformTransactionId': data?.platformTransactionId
                    };
                    let jsonResponse = JSON.stringify(emvResponse);
                    element.form.emv_websocket_resonse.value = jsonResponse;
                }
                if(typeof data.DeviceService !== 'undefined') {
                    element.form.emv_device_service.value = data.DeviceService;
                }

                if(typeof data.DeviceGuid !== "undefined") {
                    element.form.emv_device_guid.value = data.DeviceGuid;
                }

                if(typeof data.DeviceExtensions !== "undefined") {
                    element.form.emv_device_extensions.value = data.DeviceExtensions;
                }

                if(typeof data.sessionKey !== "undefined") {
                    element.form.emv_device_session_key.value = data.sessionKey;
                }

                if(typeof data.expiresAt !== "undefined") {
                    element.form.emv_device_session_expires_at.value = data.expiresAt;
                }

                element.form.cc_type.value = 'info';
                element.form.onsubmit();
            } catch (error) {
                jQuery.caAlert('Terminal Error Occurred');
                console.error(error);
            }
        });
    },

    /**
     * Set params
     */
    setParams: function(params) {
        this.params = params;
    },

    /**
     * Open Receipt Row page
     */
    openReceiptRow: function(receiptRowId) {
        window.open('/payment/print-receipt-row?receiptId=' + receiptRowId);
    },

    /**
     * Initialize
     */
    init: function(params) {
        if (params.singlePopup) {
            if (params.printReceipt) {
                window.open('/payment/receipt?id=' + params.receiptId + '&print=1&nodashboard=1' + params.emailLink);
            } else if (params.emailReceipt) {
                window.open('/payment/receipt?id=' + params.receiptId + '&print=1&nodashboard=1' + params.emailLink + '&emailOnly=true');
            }
            //in addition if fully paid close popup window
            (function($) {
                if ($('#takePaymentForm').closest('.dialog').find('.alphacube_close').length > 0) {
                    $('#takePaymentForm').closest('.dialog').find('.alphacube_close').trigger('click');
                    $.caDialogCloseAll();
                } else {
                    $('#takePaymentForm').closest('.ui-dialog-content').caDialog('close');
                }

                if (params.callbackJs) {
                    if (params.callbackJs === '_attendancePayCallback') {
                        if ($.isFunction($.fn.caStandAloneRoster)) {
                            $('.content-wrapper').caStandAloneRoster(
                                'attendancePayCallback',
                                params.callbackJsParams
                            );
                        }
                    } else if (params.callbackJs === 'reload_courts') {
                        $j('#btnRefresh').trigger('change');
                    } else if (params.callbackJs === 'reload') {
                        location.reload();
                    }
                }
            })(jQuery);
        } else {
            if(params.printReceipt) {
                window.location = params.baseUrl + 'payment/receipt?id=' + params.receiptId + params.emailLink;
            } else if (params.emailReceipt) {
                window.location = params.baseUrl + 'payment/receipt?id=' + params.receiptId + params.emailLink + '&emailOnly=true';
            } else {
                window.location = params.baseUrl;
            }
        }
    },

    redirectToProfile: function (userId) {
        window.location = '/user/edit?id='+userId;
    }
};

window.TakePayment = TakePayment;
